import { ServiceTypeIceCubeStylePipe } from '@aca-new/app/shared/pipes/service-type-ice-cube-style/service-type-ice-cube-style.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [ServiceTypeIceCubeStylePipe],
  exports: [ServiceTypeIceCubeStylePipe],
})
export class ServiceTypeIceCubeStyleModule {}
